import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { ArrowUpRight, Apple, Disc3, Headphones, Instagram, Music2, Twitter, Youtube, Globe } from "lucide-react";
import { api } from "@/lib/api";
import { Logo } from "@/components/Logo";

const ICONS = { instagram: Instagram, youtube: Youtube, tiktok: Music2, x: Twitter, spotify: Disc3, soundcloud: Headphones, "apple music": Apple };

export default function Socials() {
  const [socials, setSocials] = useState([]);

  useEffect(() => {
    api.get("/socials").then((r) => setSocials(r.data)).catch(() => {});
  }, []);

  return (
    <div className="mx-auto flex min-h-[70vh] max-w-lg flex-col items-center px-4 py-16 sm:py-24" data-testid="socials-page">
      <motion.div initial={{ opacity: 0, scale: 0.9 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.6 }}>
        <Logo size={72} />
      </motion.div>
      <motion.h1
        initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.15, duration: 0.6 }}
        className="font-heading mt-5 text-2xl font-extrabold text-white"
      >
        PRODRUSHI
      </motion.h1>
      <motion.p
        initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.25, duration: 0.6 }}
        className="mt-2 text-center font-mono text-xs uppercase tracking-widest text-emerald-300"
      >
        Beats · Studio · Videos — Atlanta, GA
      </motion.p>

      <div className="mt-10 w-full space-y-3">
        {socials.map((s, i) => {
          const Icon = ICONS[s.platform.toLowerCase()] || Globe;
          return (
            <motion.a
              key={s.id}
              href={s.url}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`social-link-${s.platform.toLowerCase()}`}
              initial={{ opacity: 0, y: 16 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.3 + i * 0.08, duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              className="group flex items-center gap-4 rounded-2xl border border-white/10 bg-[#141419] px-5 py-4 transition-colors hover:border-emerald-300/50"
            >
              <span className="flex h-10 w-10 items-center justify-center rounded-full border border-emerald-300/30 bg-black/40 text-emerald-200">
                <Icon size={17} />
              </span>
              <span className="flex-1">
                <span className="block text-sm font-bold text-white">{s.platform}</span>
                {s.handle && <span className="block text-xs text-zinc-500">{s.handle}</span>}
              </span>
              <ArrowUpRight size={16} className="text-zinc-600 transition-colors group-hover:text-emerald-200" />
            </motion.a>
          );
        })}
      </div>
    </div>
  );
}
